export default {
  employeeRoomList: [],
  participants: [],
  unreadCount: 0,
  clientRoomId: null,
  selectedChat: {},
};
